import {Component, Input} from "@angular/core";

@Component({
    selector: 'tfl-bo-tab',
    template: `
        <ng-content></ng-content>
    `
})
export class TabComponent {

    @Input() title: string;
    @Input() navigationPoint: string[] = [];

    @Input() active: boolean = false;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/bo-tabs/tab.component.ts